import { Capacitor, registerPlugin } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { PUSH_CHANNELS } from "./channels.js";

const DriverTracking = registerPlugin("DriverTracking");

async function createChannelsSafe() {
  for (const channel of PUSH_CHANNELS) {
    try {
      await PushNotifications.createChannel(channel);
    } catch (e) {
      console.warn("[driver-push] createChannel failed:", channel?.id, e);
    }
  }
}

export async function ensurePushPermission() {
  if (!Capacitor.isNativePlatform()) {
    return { ok: false, reason: "not_native" };
  }

  const platform = String(Capacitor?.getPlatform?.() || "").toLowerCase();

  // REISOR_NATIVE_NOTIFICATION_PERMISSION_V1
  if (platform === "android") {
    try {
      const state = await DriverTracking.checkNotificationPermission();

      if (state?.granted === true) {
        return { ok: true, reason: "granted" };
      }

      await DriverTracking.requestNotificationPermission();

      return { ok: true, reason: "native_permission_requested" };
    } catch (e) {
      console.warn("[driver-push] native permission bridge failed:", e);
      return { ok: true, reason: "native_permission_bridge_fallback" };
    }
  }

  return { ok: true, reason: "native_non_android_register_only" };
}

export async function registerPush({ onToken, onNotification, onAction } = {}) {
  const perm = await ensurePushPermission();
  if (!perm.ok) return perm;

  await createChannelsSafe();

  try {
    await PushNotifications.removeAllListeners();
  } catch {}

  await PushNotifications.addListener("registration", async (token) => {
    try {
      const value = String(token?.value || "").trim();
      console.log("[driver-push] registration event:", value ? value.slice(0, 24) : "");
      if (value) await onToken?.(value);
    } catch (e) {
      console.error("[driver-push] onToken failed:", e);
    }
  });

  await PushNotifications.addListener("registrationError", (err) => {
    console.error("[driver-push] registration error:", err);
  });

  await PushNotifications.addListener("pushNotificationReceived", (notification) => {
    try {
      console.log("[driver-push] received:", notification);
      onNotification?.(notification);
    } catch (e) {
      console.error("[driver-push] onNotification failed:", e);
    }
  });

  await PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    try {
      console.log("[driver-push] action performed:", action);
      onAction?.(action);
    } catch (e) {
      console.error("[driver-push] onAction failed:", e);
    }
  });

  console.log("[driver-push] listeners ready, calling native register");
  await PushNotifications.register();

  return { ok: true, listenersReady: true, registerCalled: true };
}
